import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClick = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 250,
	height: 250,
	fill: "none",
	viewBox: "0 0 250 250",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		clipPath: "url(#Click-73f04b_a)",
		clipRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#Click-73f04b_b)",
				d: "m195.712 115.492-16.935 27.566 61.182 37.588-3.141 5.112-66.294-40.729 14.331-23.327-78.344 1.509 34.062 70.569 14.331-23.327 15.401 9.462-3.141 5.112-10.288-6.321-16.936 27.566-42.9-88.879z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#Click-73f04b_c)",
				d: "M106.104 178.321v56.744h-6v-56.744z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#Click-73f04b_d)",
				d: "M106.104 14.063v56.744h-6V14.063z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#Click-73f04b_e)",
				d: "M228.525 189.567h-.002l-20.023 6.721c-9.913 3.333-19.803 2.073-28.623-3.452l-12.713-7.81 3.141-5.112 12.735 7.824.011.007c7.331 4.595 15.358 5.605 23.537 2.856l.002-.001 20.03-6.723c9.931-3.32 21.35-1.919 30.181 3.611l22.891 14.063-3.141 5.112-22.914-14.077-.011-.007c-7.322-4.589-16.88-5.76-25.101-3.012"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#Click-73f04b_f)",
				d: "m75.659 171.136-32.852 44.798-4.839-3.548 32.852-44.798z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#Click-73f04b_g)",
				d: "M53.332 142.326 2.56 160.245l-1.997-5.658 50.77-17.919z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#Click-73f04b_h)",
				d: "M51.487 109.523.716 94.59l1.693-5.756 50.77 14.933z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#Click-73f04b_i)",
				d: "M70.949 81.704 38.097 42.879l4.58-3.876L75.53 77.828z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#Click-73f04b_j)",
				d: "M171.227 36.742 138.376 81.54l-4.839-3.548 32.852-44.798z"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "Click-73f04b_b",
			x1: 181.613,
			x2: 217.017,
			y1: 145.591,
			y2: 166.21,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .25,
				stopColor: "var(--chakra-colors-illustration-fg)"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--chakra-colors-illustration-fgInverted)",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "Click-73f04b_c",
			x1: 103.544,
			x2: 93.64,
			y1: 208.244,
			y2: 181.522,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--chakra-colors-illustration-fg)" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--chakra-colors-illustration-fgInverted)",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "Click-73f04b_d",
			x1: 103.544,
			x2: 98.168,
			y1: 44.086,
			y2: 71.484,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--chakra-colors-illustration-accent)" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--chakra-colors-illustration-accent)",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "Click-73f04b_e",
			x1: 216.368,
			x2: 253.202,
			y1: 180.15,
			y2: 188.729,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .239,
				stopColor: "var(--chakra-colors-illustration-fg)"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--chakra-colors-illustration-fgInverted)",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "Click-73f04b_f",
			x1: 53.331,
			x2: 72.805,
			y1: 196.091,
			y2: 168.252,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--chakra-colors-illustration-accent)" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--chakra-colors-illustration-accent)",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "Click-73f04b_g",
			x1: 27.607,
			x2: 52.941,
			y1: 147.074,
			y2: 141.251,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--chakra-colors-illustration-fg)" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--chakra-colors-illustration-fgInverted)",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "Click-73f04b_h",
			x1: 26.038,
			x2: 50.824,
			y1: 101.639,
			y2: 108.475,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--chakra-colors-illustration-accent)" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--chakra-colors-illustration-accent)",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "Click-73f04b_i",
			x1: 58.259,
			x2: 73.24,
			y1: 62.118,
			y2: 82.717,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--chakra-colors-illustration-fg)" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--chakra-colors-illustration-fgInverted)",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "Click-73f04b_j",
			x1: 153.828,
			x2: 137.582,
			y1: 56.145,
			y2: 79.079,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--chakra-colors-illustration-fg)" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--chakra-colors-illustration-fgInverted)",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "Click-73f04b_a",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 0h250v250H0z"
			})
		})
	] })]
});
export default SvgClick;
